import React from "react";
import Helmet from "react-helmet";
import PostListing from "../components/PostListing/PostListing";
import config from "../../data/SiteConfig";
import SEO from "../components/SEO/SEO";
import HeaderPage from "../components/Header/HeaderPage";
import Header from "../components/Header/Header";
import Menu from "../components/Menu/Menu";
import Footer from "../components/Footer/Footer";
import picture from "./img/tags.jpg";
import styles from "./category.module.scss";


export default class CategoryTemplate extends React.Component {
  render() {
    const category = this.props.pathContext.category;
    const postEdges = this.props.data.allMarkdownRemark.edges;
    const { slug } = this.props.pathContext;
    const postNode = {
      "frontmatter": {
          "title": {category},
          "description": `Les actualités générales et techniques à propos de la catégorie "${category}" du monde web`,
          "cover": ""
      }
    };

  let title = category;
  let description = "";
    return (
      <div className={styles.categorycontainer}>
        <Helmet title={`Les actualités "${category}" | ${config.siteTitle}`} />
        <SEO postPath={slug} postNode={postNode} postSEO />
        <Menu />
        <Header />
        <HeaderPage title={title} description={description} picture={picture}/>
        <section className="container">
        <p className={`text-center ${styles.summary}`}>Découvrez tous nos articles à propos de la catégorie <strong>{category}</strong>.</p>
          <div className={styles.postlist}>
            <PostListing postEdges={postEdges} />
          </div>
          </section>
        <Footer />
      </div>
    );
  }
}

/* eslint no-undef: "off"*/
export const pageQuery = graphql`
  query CategoryPage($category: String) {
    allMarkdownRemark(
      limit: 1000
      sort: { fields: [frontmatter___date], order: DESC }
      filter: { frontmatter: { category: { eq: $category } } }
    ) {
      totalCount
      edges {
        node {
          fields {
            slug
          }
          excerpt
          timeToRead
          frontmatter {
            title
            tags
            cover
            date
          }
        }
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/templates/category.jsx